/* ============================================================================
   GLORY BIH CHECKOUT MODAL
   
   Presretne klik na "Kreni na plaćanje" ili "Kupi odmah" za BiH posetioce
   i prikazuje modal sa KM iznosima + warning o RSD checkout-u.
   
   Aktivira se samo kad je window.GLORY.isBiH === true (iz glory-geo.liquid)
   i kad je test mode uključen, tj. na BiH market-u.
   ============================================================================ */

(function() {
  'use strict';

  // ========================================
  // KONSTANTE
  // ========================================
  var BIH_DOSTAVA_KM = 15;  // Fiksna dostava u KM
  var MODAL_ID = 'glory-bih-modal';
  var OVERLAY_ID = 'glory-bih-overlay';

  // ========================================
  // HELPER-I
  // ========================================
  
  /**
   * Proverava da li je posetilac iz BiH.
   * window.GLORY se postavlja u glory-geo.liquid snippet-u.
   */
  function isBiHVisitor() {
    return window.GLORY && window.GLORY.isBiH === true;
  }

  /**
   * Konvertuje RSD u KM sa zaokruživanjem GORE (Math.ceil).
   * Npr. 6000 RSD × 0.01666 = 99.96 KM → 100 KM
   *      6001 RSD × 0.01666 = 99.98 KM → 100 KM
   *      6010 RSD × 0.01666 = 100.13 KM → 101 KM (zaokruženo gore)
   */
  function rsdToKm(rsdAmount) {
    var kurs = (window.GLORY && window.GLORY.rsdToKm) 
               ? parseFloat(window.GLORY.rsdToKm) 
               : 0.01666;
    var km = rsdAmount * kurs;
    return Math.ceil(km);
  }

  /**
   * Fetch-uje trenutnu korpu iz Shopify Ajax API-ja.
   * total_price je u centima/para (Shopify standard).
   */
  function fetchCartTotal() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) { 
      if (!r.ok) throw new Error('Cart fetch failed');
      return r.json(); 
    })
    .then(function(cart) {
      // Shopify total_price je u centima → delim sa 100 da dobijem RSD
      var totalRsd = cart.total_price / 100;
      return totalRsd;
    });
  }

  /**
   * Formatira broj sa tačkama za hiljade (srpski format).
   * 1500 → "1.500", 150 → "150"
   */
  function formatBroj(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // ========================================
  // MODAL — KREIRANJE I PRIKAZ
  // ========================================

  /**
   * Kreira HTML za modal i ubacuje u body.
   * Ako već postoji, samo ga update-uje.
   */
  function createModal(data) {
    // Ako postoji, ukloni
    var existing = document.getElementById(MODAL_ID);
    if (existing) existing.remove();
    var existingOverlay = document.getElementById(OVERLAY_ID);
    if (existingOverlay) existingOverlay.remove();

    // Overlay — INLINE STYLE da se zaobiđe CSS keš
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'glory-bih-modal__overlay';
    // BRUTE FORCE inline style — preglasava sve sa cssText.important
    overlay.style.cssText = [
      'display: block',
      'visibility: visible',
      'position: fixed',
      'top: 0',
      'left: 0',
      'right: 0',
      'bottom: 0',
      'width: 100vw',
      'height: 100vh',
      'background-color: rgba(0, 0, 0, 0.85)',
      'z-index: 2147483646',
      'opacity: 0',
      'transition: opacity 0.25s ease',
      'cursor: pointer',
      'pointer-events: auto'
    ].join(' !important;') + ' !important;';

    // Modal — inline z-index da preglasa sve
    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'glory-bih-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'glory-bih-modal-title');
    modal.style.zIndex = '2147483647';

    modal.innerHTML = [
      '<button type="button" class="glory-bih-modal__close" aria-label="Zatvori">',
      '  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">',
      '    <line x1="4" y1="4" x2="16" y2="16"/>',
      '    <line x1="16" y1="4" x2="4" y2="16"/>',
      '  </svg>',
      '</button>',
      '',
      '<div class="glory-bih-modal__header">',
      '  <h2 id="glory-bih-modal-title" class="glory-bih-modal__title">Plaćanje pouzećem</h2>',
      '  <p class="glory-bih-modal__subtitle">Dostava u Bosnu i Hercegovinu</p>',
      '</div>',
      '',
      '<div class="glory-bih-modal__body">',
      '  <div class="glory-bih-modal__row">',
      '    <span class="glory-bih-modal__row-label">Vrednost porudžbine</span>',
      '    <span class="glory-bih-modal__row-value">' + formatBroj(data.itemsKm) + ' KM</span>',
      '  </div>',
      '  <div class="glory-bih-modal__row">',
      '    <span class="glory-bih-modal__row-label">Dostava</span>',
      '    <span class="glory-bih-modal__row-value">' + BIH_DOSTAVA_KM + ' KM</span>',
      '  </div>',
      '  <div class="glory-bih-modal__row glory-bih-modal__row--total">',
      '    <span class="glory-bih-modal__row-label">Ukupno za plaćanje</span>',
      '    <span class="glory-bih-modal__row-value">' + formatBroj(data.totalKm) + ' KM</span>',
      '  </div>',
      '',
      '  <div class="glory-bih-modal__notice">',
      '    <svg class="glory-bih-modal__notice-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">',
      '      <circle cx="10" cy="10" r="8"/>',
      '      <line x1="10" y1="6" x2="10" y2="10"/>',
      '      <line x1="10" y1="14" x2="10.01" y2="14"/>',
      '    </svg>',
      '    <div class="glory-bih-modal__notice-text">',
      '      <strong>Napomena:</strong> Na narednoj stranici (checkout) videćete iznos u <strong>RSD</strong>. To je samo tehnički prikaz — <strong>kuriru plaćate ' + formatBroj(data.totalKm) + ' KM</strong> pri preuzimanju paketa.',
      '    </div>',
      '  </div>',
      '</div>',
      '',
      '<button type="button" class="glory-bih-modal__cta">',
      '  Razumem, nastavljam',
      '</button>'
    ].join('\n');

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    // Body scroll lock
    document.body.style.overflow = 'hidden';

    // Fade-in animacija (double-rAF da CSS transitions rade)
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.style.setProperty('opacity', '1', 'important');
        overlay.classList.add('is-active');
        modal.classList.add('is-active');
      });
    });

    // Handlers
    var ctaBtn = modal.querySelector('.glory-bih-modal__cta');
    var closeBtn = modal.querySelector('.glory-bih-modal__close');

    ctaBtn.addEventListener('click', function() {
      // Redirect na Shopify checkout
      window.location.href = '/checkout';
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    // ESC key zatvara
    function escHandler(e) {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', escHandler);
      }
    }
    document.addEventListener('keydown', escHandler);
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    if (!modal) return;

    modal.classList.remove('is-active');
    if (overlay) {
      overlay.classList.remove('is-active');
      overlay.style.setProperty('opacity', '0', 'important');
    }

    setTimeout(function() {
      if (modal) modal.remove();
      if (overlay) overlay.remove();
      document.body.style.overflow = '';
    }, 300);
  }

  // ========================================
  // MAIN HANDLERS
  // ========================================

  /**
   * Glavna funkcija — poziva se na klik "Kreni na plaćanje" (cart drawer/page).
   * Korpa je već popunjena, samo treba prikazati modal.
   */
  function handleCheckoutClick(e) {
    if (!isBiHVisitor()) return;
    
    e.preventDefault();
    e.stopPropagation();

    fetchCartTotal()
      .then(function(totalRsd) {
        if (totalRsd <= 0) {
          // Prazna korpa — ne prikazuj modal
          return;
        }
        showModal(totalRsd);
      })
      .catch(function(err) {
        console.error('[Glory BiH Modal] checkout error:', err);
        // Fallback — direktno na checkout
        window.location.href = '/checkout';
      });
  }

  /**
   * Specijalna funkcija za "Kupi odmah" na product stranici.
   * MORA prvo da doda proizvod u korpu, pa onda da prikaže modal.
   */
  function handleBuyNowClick(e) {
    if (!isBiHVisitor()) return;
    
    e.preventDefault();
    e.stopPropagation();

    // Nađi product form
    var btn = e.target.closest('button, a');
    var form = btn ? btn.closest('form') : null;
    if (!form) form = document.getElementById('GloryProductForm');
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    
    if (!form) {
      console.error('[Glory BiH Modal] Buy Now: nema form');
      window.location.href = '/checkout';
      return;
    }

    // Disable dugme dok traje
    if (btn) btn.disabled = true;
    var originalText = btn ? btn.textContent : '';
    var labelEl = btn ? btn.querySelector('span') : null;
    if (labelEl) labelEl.textContent = 'Dodavanje...';

    // 1. POST proizvod u korpu
    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed (' + r.status + ')');
      return r.json();
    })
    .then(function() {
      // 2. Fetch fresh cart (potreban i za total i za section refresh)
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      var totalRsd = cart.total_price / 100;
      if (totalRsd <= 0) {
        throw new Error('Cart total is 0 after add');
      }
      
      // 3. Refresh cart drawer + cart icon — da kad user klikne X, vidi pravo stanje
      refreshCartUI(cart);
      
      // 4. Prikaži modal sa novim total-om
      showModal(totalRsd);
      
      // Vrati dugme u normalno stanje
      if (btn) btn.disabled = false;
      if (labelEl) labelEl.textContent = 'KUPI ODMAH';
    })
    .catch(function(err) {
      console.error('[Glory BiH Modal] Buy Now error:', err);
      // Vrati dugme
      if (btn) btn.disabled = false;
      if (labelEl) labelEl.textContent = 'KUPI ODMAH';
      // User-friendly error
      alert('Greška pri dodavanju proizvoda. Pokušajte ponovo.');
    });
  }

  /**
   * Osvežava cart drawer i cart icon u DOM-u + emituje cart-update event.
   * Tako kad kupac klikne X u modal-u, drawer pokazuje pravo stanje.
   */
  function refreshCartUI(cart) {
    // 1. Update cart icon count na header-u
    document.querySelectorAll('[data-glory-cart-count]').forEach(function(el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
    document.querySelectorAll('.cart-count-bubble span:first-child, .cart-count').forEach(function(el) {
      el.textContent = cart.item_count;
    });
    
    // 2. Refresh cart drawer sadržaja iz Shopify Sections API
    fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        // Cart drawer
        var drawer = document.querySelector('cart-drawer');
        if (drawer && data['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data['cart-drawer'], 'text/html');
          var newDrawerContent = doc.querySelector('cart-drawer');
          if (newDrawerContent) {
            // Sačuvaj fresh klase (is-empty se uklanja kad ima proizvoda)
            if (newDrawerContent.className) {
              drawer.className = newDrawerContent.className;
            }
            drawer.innerHTML = newDrawerContent.innerHTML;
          }
        }
        
        // Cart icon bubble (count badge na header-u)
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data['cart-icon-bubble']) {
          var bubbleParser = new DOMParser();
          var bubbleDoc = bubbleParser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.getElementById('cart-icon-bubble');
          if (newBubble) {
            bubble.innerHTML = newBubble.innerHTML;
          }
        }
      })
      .catch(function(err) {
        console.warn('[Glory BiH Modal] Cart refresh failed (not critical):', err);
      });

    // 3. Emit Shopify PubSub event (Dawn pattern)
    if (typeof window.PubSub !== 'undefined' && typeof window.PubSub.publish === 'function') {
      window.PubSub.publish('cart-update', { source: 'glory-bih-modal', cartData: cart });
    }
    
    // 4. Custom events — za bilo koji listener
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));
  }

  /**
   * Helper — prikazuje modal za dat RSD total.
   */
  function showModal(totalRsd) {
    var itemsKm = rsdToKm(totalRsd);
    var totalKm = itemsKm + BIH_DOSTAVA_KM;

    createModal({
      totalRsd: totalRsd,
      itemsKm: itemsKm,
      totalKm: totalKm
    });
  }

  // ========================================
  // EVENT BINDING
  // ========================================

  /**
   * Poveži klikove na sve relevantne dugmiće.
   * Razlikujem 2 tipa: "Kreni na plaćanje" (checkout) vs "Kupi odmah" (buy-now)
   * jer "Kupi odmah" mora prvo da DODA proizvod u korpu.
   */
  function bindCheckoutButtons() {
    // CHECKOUT — korpa je već popunjena, samo prikaži modal
    var CHECKOUT_SELECTORS = [
      // Cart drawer "Kreni na plaćanje"
      '.glory-cart-drawer__checkout',
      'a.glory-cart-drawer__checkout',
      'button.glory-cart-drawer__checkout',
      // Cart drawer Dawn default
      '#CartDrawer-Checkout',
      'cart-drawer button[name="checkout"]',
      // Cart page "Kreni na plaćanje" (Glory custom CTA)
      '.glory-cart-page__checkout-cta',
      'a.glory-cart-page__checkout-cta',
      // Cart page form (Dawn default)
      'form[action="/cart"] button[name="checkout"]',
      'form[action="/checkout"] button[type="submit"]'
    ].join(', ');

    // BUY NOW — moramo prvo dodati proizvod u korpu
    var BUY_NOW_SELECTORS = [
      '#GloryBuyNowButton',
      '.glory-product-form__buy-now',
      'button[data-glory-buy-now]',
      'button.glory-buy-now'
    ].join(', ');

    document.body.addEventListener('click', function(e) {
      if (!isBiHVisitor()) return;

      // Prvo proveri Buy Now (više specifičan)
      var buyNow = e.target.closest(BUY_NOW_SELECTORS);
      if (buyNow) {
        handleBuyNowClick(e);
        return;
      }

      // Onda Checkout
      var checkout = e.target.closest(CHECKOUT_SELECTORS);
      if (checkout) {
        handleCheckoutClick(e);
        return;
      }
    }, true);  // capture = true — uhvati PRE drugih handler-a
  }

  // ========================================
  // INIT
  // ========================================
  
  function init() {
    // Čeka da window.GLORY bude postavljen (glory-geo.liquid)
    if (typeof window.GLORY === 'undefined') {
      // Pokušaj opet posle malo — GLORY se postavi inline u head
      setTimeout(init, 100);
      return;
    }

    // Bind handler
    bindCheckoutButtons();

    console.log('[Glory BiH Modal] Initialized. isBiH=' + (window.GLORY.isBiH ? 'YES' : 'no'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();